"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepperWrapper = exports.StepDivider = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const StepDivider = exports.StepDivider = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "egvzgek1"
} : {
  target: "egvzgek1",
  label: "StepDivider"
})(props => /*#__PURE__*/(0, _react.css)("height:3px;width:30px;margin-top:1rem;background-color:", props.color, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StepDivider;")));
var _ref = process.env.NODE_ENV === "production" ? {
  name: "jpgenn",
  styles: "display:flex;justify-content:space-between;padding:0 2.5em;align-items:top;margin-bottom:1.5em;@media screen and (max-width: 768px){padding:0 0.5em;span{font-size:12px;}}"
} : {
  name: "9i9w2h-StepperWrapper",
  styles: "display:flex;justify-content:space-between;padding:0 2.5em;align-items:top;margin-bottom:1.5em;@media screen and (max-width: 768px){padding:0 0.5em;span{font-size:12px;}};label:StepperWrapper;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const StepperWrapper = exports.StepperWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "egvzgek0"
} : {
  target: "egvzgek0",
  label: "StepperWrapper"
})(props => _ref);